import { render, staticRenderFns } from "./QCustomer.vue?vue&type=template&id=9642156c&scoped=true&"
import script from "./QCustomer.vue?vue&type=script&lang=js&"
export * from "./QCustomer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9642156c",
  null
  
)

export default component.exports